function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "variant", "component", "initializing", "html", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { memo } from 'react';
import PropTypes from 'prop-types';
import Box from "../Box";
import typography from "../../../design-system/scss/components/typography.module.scss";
import { componentType } from "../../lib/commonPropTypes";
import cls from "../../lib/cls";
import { jsx as _jsx } from "react/jsx-runtime";
var variantMap = {
  title: 'h1',
  headline: 'h1',
  'secondary-headline': 'h2',
  body: 'p',
  small: 'small',
  ui: 'div',
  preamble: 'p',
  link: 'a',
  icon: 'i',
  mail: 'div'
};
function Typography(_ref) {
  var children = _ref.children,
    variant = _ref.variant,
    tag = _ref.component,
    initializing = _ref.initializing,
    html = _ref.html,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classNames = ['text'];
  if (className) {
    classNames.push.apply(classNames, _toConsumableArray(className.split(' ')));
  }
  var component = tag || variantMap[variant];
  if (variant) {
    classNames.push(variant);
  }
  if (initializing) {
    classNames.push('is-initializing');
  }
  if ('className' in props) {
    classNames.push(props.className);
  }
  var dangerousHtml = html ? {
    __html: html
  } : null;
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, props), {}, {
    dangerouslySetInnerHTML: dangerousHtml,
    className: cls(classNames, typography),
    component: component,
    children: children
  }));
}
Typography.defaultProps = {
  variant: null,
  component: null,
  className: undefined,
  children: null,
  initializing: false,
  html: null
};
Typography.propTypes = {
  variant: PropTypes.oneOf(['title', 'headline', 'secondary-headline', 'small', 'preamble', 'body', 'ui', 'link', 'icon', 'mail']),
  component: componentType,
  children: PropTypes.node,
  className: PropTypes.string,
  initializing: PropTypes.bool,
  html: PropTypes.string
};
export default /*#__PURE__*/memo(Typography);